import React, { memo } from "react";

import * as S from "./styles";
import { useTranslation } from "react-i18next";
import { useParams, useHistory } from "react-router-dom";
import { cleanText } from "../../../utils/models/anchor-text";
import moment from "moment";
import Tags from "../Tags/Tags";
import { whatsAppFormat } from "../../../utils/models/date";
import { messageType } from "../../../utils/models/message";
import { isFutureDate } from "modules/app/utils";
import { useMainState } from "modules/app/contexts";

export default memo(function ContactCard({ contact }) {
  const { id } = useParams();
  const { t } = useTranslation(["Contacts", "Customer"]);
  const history = useHistory();

  const {
    forwardMode,
    setSelectedForwardContacts,
    selectedForwardContacts,
  } = useMainState();

  const isSelected = selectedForwardContacts.find(
    (selected) => selected === contact.id
  );

  function showMessage(message) {
    const type = messageType(message);

    if (["audio", "image", "video", "file"].includes(type)) {
      return t(`messages.type.${type}`);
    } else if (Boolean(message?.body)) {
      return cleanText(message.body);
    } else {
      return t("messages.resume.first_contact");
    }
  }

  function handleForwardMode(contactId) {
    const found = selectedForwardContacts.find(
      (selected) => selected === contactId
    );

    if (found) {
      const newArr = selectedForwardContacts.filter(
        (selected) => selected !== contactId
      );
      setSelectedForwardContacts(newArr);
    } else {
      setSelectedForwardContacts([...selectedForwardContacts, contactId]);
    }
  }

  function handleSelectConversation(id) {
    if (forwardMode) {
      handleForwardMode(id);
    }

    if (!forwardMode) {
      history.push(`/app/chat/${id}`);
    }
  }

  return (
    <S.ListItem
      button
      $isSelected={isSelected}
      onClick={() => handleSelectConversation(contact.id)}
      className={id == contact.id ? "current-contact" : ""}
    >
      <S.Card status={contact.status} $isSelected={isSelected}>
        <S.CardInfo>
          <S.AvatarTooltip
            title={t("Contacts:forwardMode.forwardTooltip")}
            arrow
          >
            {isSelected ? (
              <S.CheckedAvatar />
            ) : (
              <S.ContactAvatar
                src={contact.avatar_url}
                onClick={() => handleForwardMode(contact.id)}
              />
            )}
          </S.AvatarTooltip>

          {contact.is_favorite && <S.FavoriteIcon />}

          <S.Col>
            <S.Row>
              <S.ContactName noWrap={true}>{contact?.name}</S.ContactName>

              <S.ContactStatus>
                {contact.status != "filed" && <Tags contact={contact} />}

                <S.ContactUpdatedAt component="span">
                  {moment(contact.updated_at).format(
                    whatsAppFormat(contact.updated_at)
                  )}
                </S.ContactUpdatedAt>
              </S.ContactStatus>
            </S.Row>

            <S.Row>
              <S.LastMessageInfo variant="body2" component="span">
                {showMessage(contact?.last_message)}
              </S.LastMessageInfo>

              {contact.unread_messages_count > 0 &&
                contact.status != "filed" && (
                  <S.UnReadMessages>
                    {contact.unread_messages_count}
                  </S.UnReadMessages>
                )}
            </S.Row>
          </S.Col>
        </S.CardInfo>

        <S.CardFooterInfo>
          <S.LastActivity
            noWrap={true}
            $isFutureDate={isFutureDate(contact?.last_activity?.date)}
          >
            {t(
              `Customer:details.activity.${contact?.last_activity?.activity_type}`
            )}{" "}
            {moment(contact?.last_activity?.date).format("DD/MM/YYYY HH:mm")}
          </S.LastActivity>

          <S.ContactOwner>
            <S.ContactOwnerName noWrap={true}>
              {contact?.user?.name}
            </S.ContactOwnerName>
          </S.ContactOwner>
        </S.CardFooterInfo>
      </S.Card>
    </S.ListItem>
  );
});
